module.exports = "/_next/static/images/f053d78694a1e4fcc76e96a5fe267fc2-savings-lg.jpg";